/* eslint-disable import/prefer-default-export */
export const findIndexById = (collection, id) =>
  Math.max(
    collection.findIndex(element => String(id) === String(element.id)),
    0
  );
/* eslint-enable import/prefer-default-export */
